import dayjs from 'dayjs'
import jalaliday from 'jalali-plugin-dayjs'
dayjs.extend(jalaliday)

export function isSameMonth(date: Date, comparison: Date) {
    const jalaliDate1 = dayjs(date).calendar('jalali');
    const jalaliDate2 = dayjs(comparison).calendar('jalali');

    // Compare Jalali year and month
    const isSameYear = jalaliDate1.year() === jalaliDate2.year();
    const isSameMonth = jalaliDate1.month() === jalaliDate2.month();

    return isSameYear && isSameMonth;
}
